import { Navigate } from 'react-router-dom';
import { EXTENDED_FLOW, getInterviewFlow } from '../../utils/interviewFlow';
import Decision from './Decision';

/**
 * Gate for /interview.
 *
 * The extended funnel has its own entry question in place of Decision, so a
 * visitor assigned to it is sent there instead. Letting Decision render for
 * them would drop them onto a page their flow has no position for, and the
 * step after it would have nowhere to navigate.
 *
 * This reads the assignment and never creates one — somebody who opened
 * /interview directly was never enrolled and must get the control funnel.
 */
export default function InterviewEntry() {
    const flow = getInterviewFlow();

    if (flow.id === EXTENDED_FLOW.id) {
        // replace, so browser-back does not bounce between here and the gate.
        return <Navigate to={flow.entryPath} replace />;
    }

    return <Decision />;
}
